import { IconAlertTriangle } from '@bbr/icons/alert-triangle-outline';
import { For, Show, useContext } from 'solid-js';
import { cn } from 'tailwind-variants';
import { Alert } from '../components/alert.tsx';
import { FormContext } from './form.tsx';
import type { JSX } from 'solid-js';

type Props = {
	fallback?: string;
};

export function Errors(props: Props) {
	const { errors, fieldErrors } = useContext(FormContext);

	return (
		<>
			<Show when={errors().length}>
				<div class="w-full">
					<Alert variant="danger" aria-live="assertive" icon={IconAlertTriangle}>
						<Alert.Content>
							<ul>
								<For each={errors()}>{(issue) => <li>{issue}</li>}</For>
							</ul>
						</Alert.Content>
					</Alert>
				</div>
			</Show>
			<Show when={!errors().length && Object.keys(fieldErrors()).length}>
				<ErrorMessage>
					{props.fallback ?? 'There was an issue submitting the form. Please correct the errors and try again.'}
				</ErrorMessage>
			</Show>
		</>
	);
}

export function ErrorMessage(props: JSX.HTMLAttributes<HTMLParagraphElement>) {
	return <p {...props} class={cn('flex gap-x-2 text-rose-500', props.class)} aria-live="assertive" />;
}
